import React, { useEffect, useState } from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import userStore from '../../Stores/UserStore'
import sharedStore from "../../Stores/SharedStore";
import { setCookie } from '../../../Services/Authentication/AuthHelper'
import { getMorningstarHelpFile } from '../../../Services/IBS/IbsService'


const MorningstarMessageModal = observer(() => {

    const closeMessageModal = () => {
        setCookie('sawMorningstarMessage', 1, 365);
        userStore.showMorningstarMessage = false;
    }

    const clickGetMorningstarHelpFile = () => {
        getMorningstarHelpFile()
    }

    return (
        <React.Fragment>
            <section>

                <Modal
                    visible={userStore.showMorningstarMessage}
                    width="760"
                    height="450"
                    effect="fadeInDown"
                    onClickAway={closeMessageModal}
                >
                    <div className="commentModal">

                        <h3>Your survey has been prefilled with third party data.</h3>
                        <hr />

                        <h4>In our continuous effort to make the surveys easier to complete, we have prefilled a number of data fields in our survey with data from external parties. This is based on tickers or other identifiers that you have provided in the past.
                            The data was updated to reflect the year ending December {sharedStore.currentDataYear}.
                            Although the data is based on sources we believe are reliable, we ask you to check and update the information where appropriate.
                            Refer to the <span style={{ color: '#1a71c1', cursor: 'pointer' }} onClick={() => clickGetMorningstarHelpFile()}>FAQ</span> or contact <a href='mailto:janjaap@explorecem.com'>Janjaap Weeda (Product Manager - DC)</a> for more information.</h4>

                        <br />

                        <button type="button" className="btn btn-close" onClick={closeMessageModal}>Ok</button>
                    </div>
                </Modal>
            </section>
        </React.Fragment>
    );

});

export default MorningstarMessageModal;
